export const buildHostQuery = (selected, search) => {
  const { hosts, hostCollections, hostGroups } = selected;
  const hostsSearch = `(id ^ (${hosts.map(({ id }) => id).join(',')}))`;
  const hostCollectionsSearch = `(host_collection_id ^ (${hostCollections
    .map(({ id }) => id)
    .join(',')}))`;
  const hostGroupsSearch = `(hostgroup_id ^ (${hostGroups
    .map(({ id }) => id)
    .join(',')}))`;
  return [
    hosts.length ? hostsSearch : false,
    hostCollections.length ? hostCollectionsSearch : false,
    hostGroups.length ? hostGroupsSearch : false,
    search.length ? `(${search})` : false,
  ]
    .filter(Boolean)
    .join(' or ');
};



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_remote_execution-8.0.0-2.fm3_4.el8.noarch/usr/share/gems/gems/foreman_remote_execution-8.0.0/webpack/JobWizard/steps/HostsAndInputs/buildHostQuery.js